export const taiKhoanQuy = {
  sections: {
    list: { title: 'Quản lý tài khoản quỹ' },
  },
  titles: {
    add: 'Thêm tài khoản quỹ',
    edit: 'Sửa tài khoản quỹ',
    // P13 (code-review 5.3): title dialog confirm delete — spec AC-3 literal "Xóa tài khoản quỹ".
    xoaConfirm: 'Xóa tài khoản quỹ',
  },
  columns: {
    ten: 'Tên tài khoản',
    loai: 'Loại',
    chiNhanh: 'Chi nhánh',
    nganHang: 'Ngân hàng',
    soDuBanDau: 'Số dư ban đầu',
    soDuHienTai: 'Số dư hiện tại',
    trangThai: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    thaoTac: 'Thao tác',
  },
  filter: {
    searchPlaceholder: 'Tìm theo tên, tên NH, số TK...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Bộ lọc tài khoản quỹ',
    hintBody: 'Lọc theo loại, trạng thái và chi nhánh',
    chiNhanhAll: 'Tất cả chi nhánh',
    chiNhanhSearch: 'Tìm chi nhánh',
    chiNhanhEmpty: 'Không có chi nhánh',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  filterSection: {
    loai: 'Loại',
    trangThai: 'Trạng thái',
    tatCa: 'Tất cả',
  },
  loai: {
    TIEN_MAT: 'Quỹ tiền mặt',
    NGAN_HANG: 'Tài khoản ngân hàng',
  },
  trangThai: {
    DANG_HOAT_DONG: 'Hoạt động',
    NGUNG_HOAT_DONG: 'Ngừng hoạt động',
  },
  actions: {
    them: 'Thêm tài khoản quỹ',
    sua: 'Sửa',
    xoa: 'Xóa',
    kichHoat: 'Kích hoạt',
    ngungHoatDong: 'Ngừng hoạt động',
    luu: 'Lưu',
  },
  messages: {
    noData: 'Chưa có tài khoản quỹ nào.',
    saveSuccess: 'Đã lưu tài khoản quỹ.',
    saveError: 'Không thể lưu tài khoản quỹ.',
    deleteSuccess: 'Đã xóa tài khoản quỹ.',
    deleteConfirm: 'Xóa tài khoản quỹ {ten}? Hành động này không thể hoàn tác.',
    coPhieuThamChieu: 'Tài khoản đã có phiếu tham chiếu. Chỉ có thể chuyển sang Ngừng hoạt động.',
    statusChanged: 'Đã cập nhật trạng thái tài khoản quỹ.',
    xungDotVersion: 'Tài khoản quỹ đã bị thay đổi bởi người khác. Vui lòng tải lại.',
    soTaiKhoanTrung: 'Số tài khoản ngân hàng đã tồn tại trong chi nhánh.',
    tenTrung: 'Tên quỹ tiền mặt đã tồn tại trong chi nhánh.',
    // P14 (code-review 5.3): V-013 explicit branch — NGAN_HANG thiếu thông tin NH bắt buộc.
    nganHangThieuThongTin: 'Tài khoản ngân hàng phải có đủ thông tin tên NH và số tài khoản.',
    listSummary: 'Tổng {count} tài khoản',
    loadError: 'Không thể tải danh sách tài khoản quỹ.',
  },
  form: {
    ten: 'Tên tài khoản',
    loai: 'Loại tài khoản',
    nganHangTen: 'Tên ngân hàng',
    nganHangSoTaiKhoan: 'Số tài khoản',
    nganHangChiNhanh: 'Chi nhánh ngân hàng',
    chiNhanh: 'Chi nhánh',
    soDuBanDau: 'Số dư ban đầu',
    dangHoatDong: 'Trạng thái hoạt động',
    soDuHienTai: 'Số dư hiện tại',
    dangHoatDongOn: 'Đang hoạt động',
    dangHoatDongOff: 'Ngừng hoạt động',
  },
  validation: {
    tenRequired: 'Tên tài khoản là bắt buộc',
    tenMinLength: 'Tên tối thiểu 3 ký tự',
    tenMaxLength: 'Tên tối đa 100 ký tự',
    nganHangTenRequired: 'Tên ngân hàng là bắt buộc khi chọn Tài khoản ngân hàng',
    soTaiKhoanInvalid: 'Số tài khoản phải từ 6-20 chữ số',
    nganHangTenMaxLength: 'Tên ngân hàng tối đa 100 ký tự',
    nganHangChiNhanhMaxLength: 'Chi nhánh ngân hàng tối đa 100 ký tự',
    soDuBanDauRequired: 'Vui lòng nhập số dư ban đầu',
    soDuBanDauInvalid: 'Số dư ban đầu phải là số không âm',
    soDuBanDauQuaLon: 'Số dư ban đầu vượt quá giới hạn cho phép',
    chuaXacDinhChiNhanh: 'Chưa xác định chi nhánh. Vui lòng đăng nhập lại.',
    chiNhanhRequired: 'Vui lòng chọn ít nhất 1 chi nhánh.',
  },
  placeholders: {
    formTitle: 'Nhập tên tài khoản...',
    formBody: '',
    soDuBanDau: '0',
    nganHangSoTaiKhoan: 'Nhập 6-20 chữ số',
  },
  detailTabs: {
    phieuThu: 'Phiếu thu',
    phieuChi: 'Phiếu chi',
  },
  expand: {
    rowClickExpand: 'Nhấn dòng để xem phiếu thu / phiếu chi',
    noPhieuThu: 'Chưa có phiếu thu trên tài khoản này.',
    noPhieuChi: 'Chưa có phiếu chi trên tài khoản này.',
    loadError: 'Không tải được danh sách phiếu.',
    retry: 'Thử lại',
    viewAll: 'Xem tất cả',
    count: '{count} phiếu',
  },
}
